'use strict';

var templateHome = require('../templates/icons/home-icon.tpl');
var templateWise = require('../templates/icons/appwise-icon.tpl');
var templateInsight = require('../templates/icons/appinsight-icon.tpl');
var templateMarketplace = require('../templates/icons/marketplace-icon.tpl');
var templateUserImgs = require('../templates/icons/user-img-icon.tpl');

// AppWise App IDs
var appWise = 42937,
	appWiseDev = 189629,
	appInsight = 10030,
	appInsightDev = 189746;

function IconItems() {}

function getAppLink(id, defaultId, myapps) {
	return myapps.find(function(app) {
		return id === app.applicationId || defaultId === app.applicationId;
	}).launchUrl;
}

IconItems.prototype.renderHome = function(config, deps) {
	var _ = deps.underscore;
	var l = deps.l10nFn;
	var marketUrl = config.marketUrl;
	var app = config.myapps && config.myapps.content && config.myapps.content.find(function(item) {
		return item.applicationId === appWise || item.applicationId === appWiseDev;
	});
	if (app) {
		var target = encodeURIComponent(marketUrl + '/appwise/feeds/recents');
		var href = getAppLink(appWise, appWiseDev, config.myapps.content) + '&targetUrl=' + target;
		var options = Object.assign(
			{},
			app,
			{
				tooltipLabel: l('Home'),
				href: href || ''
			}
		);
		return _.template(templateHome)(options);
	}
	return '';
};

IconItems.prototype.renderAppWise = function(config, deps) {
	var _ = deps.underscore;
	var l = deps.l10nFn;
	var marketUrl = config.marketUrl;
	var app = config.myapps && config.myapps.content && config.myapps.content.find(function(item) {
		return item.applicationId === appWise || item.applicationId === appWiseDev;
	});
	if (app) {
		var target = encodeURIComponent(marketUrl + '/appwise/messages');
		var href = getAppLink(appWise, appWiseDev, config.myapps.content) + '&targetUrl=' + target;
		var options = Object.assign(
			{},
			app,
			{
				tooltipLabel: l('Teams'),
				href: href || ''
			}
		);
		return _.template(templateWise)(options);
	}
	return '';
};

IconItems.prototype.renderAppInsight = function(config, deps) {
	var _ = deps.underscore;
	var l = deps.l10nFn;

	var app = config.myapps && config.myapps.content && config.myapps.content.find(function(item) {
		return item.applicationId === appInsight || item.applicationId === appInsightDev;
	});
	if (app) {
		var href = getAppLink(appInsight, appInsightDev, config.myapps.content);
		var options = Object.assign(
			{},
			app,
			{
				tooltipLabel: l('Insights'),
				href: href || ''
			}
		);
		return _.template(templateInsight)(options);
	}
	return '';
};

IconItems.prototype.renderUserImg = function(config, deps) {
	var _ = deps.underscore;
	var userImg = config.UserInfo && config.UserInfo.profilePic;
	if (userImg) {
		var options = Object.assign(
			{},
			{ userImg: config.IMG_BASE + '/profilePics/' + userImg }
		);
		return _.template(templateUserImgs)(options);
	}
	return '';
};

IconItems.prototype.renderMarketplace = function(config, deps) {
	var _ = deps.underscore;
	var l = deps.l10nFn;

	var options = {
		tooltipLabel: l('Marketplace'),
		href: config.CHANNEL_SETTINGS.channelCanonicalBaseUrl + '/home' || ''
	};
	return _.template(templateMarketplace)(options);
};


module.exports = IconItems;



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/IconItems.js
// module id = 40
// module chunks = 0